export const GENERIC_FILTER_OPTIONS_DEFAULT_PAGING = 10;

export const GENERAL_FILTER_DEBOUNCE = 500;
export const PARTICULAR_FILTER_DEBOUNCE = 500;